import {Button, DatePicker, InputNumber, message, Modal, Select, Spin} from 'antd'
import React from 'react'
import { CustomRow, CustomCol } from '../../components/Custom';
import { Row,Col,Form, Input } from "antd";
import moment from 'moment';

import {config, post, postFrom, transterQuery} from '../../axios';
import {
    API_CHECKLIST,
    API_device_findList,
    API_device_writeOffAdd,
    API_GETDEVICEBILLWRITEOFFBYID,
    API_GETROOMDEVICEBILLBYPROJECTIDANDCYCLEDATE,
    API_project_findProjectListByMerchantId,
    API_salesroom_findList
} from '../../axios/config';
import {handleExportParams} from "../../utils";
import DetailTitle from "../../components/DetailTitle";
import FileUpload from "../../components/FileUpload";
import TextArea from "antd/lib/input/TextArea";
const Option = Select.Option;
class DeviceDetail extends React.Component{
  state = {
    id: null,
    visible: false,
  datePickerOpen: false,
  datePickerData: null,
      projectId: 0,
    dataInfo: {},
      repairReportId: 0,
      projectData: [],
    salesroomList: [],
      deviceList:[],
      params:{
          leaseTermTime: null
      },
    dataLoading: false,
    submitLoading: false,
    data: {
        houseLayout: []
    }
  }
  open(id = null) {
      this.setState({ visible: false,cycleDate:null ,registrationDate:null,projectId:null,newTransferMoney:0,data: {}})
      postFrom({
          url: config.API_project_findProjectListByMerchantId,
          data: {}
      }).then(res => {
          let projectData = res.map(item => ({ title: item.name, value: item.id, name: item.name  }));
          this.setState({ projectData });
      }).catch(err => {
          message.error(err.message || '获取商户列表失败');
          this.setState({ dataLoading: false });
      });
      if (this.fileUploadRef) {
          this.fileUploadRef.setFileToState([]);
      }
    this.setState({ visible: true, id,params:{leaseTermTime: null} })
    return new Promise((resolve,reject) => {
      this.monitor = { resolve, reject }
    })
  }

  close() {
    this.setState({ visible: false,cycleDate:null ,registrationDate:null,projectId:null,newTransferMoney:0,data: {}})
    this.props.form.resetFields()
  }
  renderFooter() {
    return (
      <div className="app-modal-footer">
          <Button type="primary" onClick={this.handleOk.bind(this)} loading={this.state.submitLoading}>保存</Button>
        <Button onClick={this.close.bind(this)}>取消</Button>
      </div>
    )
  }

  postSalesroomList() {
    post({ url: API_salesroom_findList }).then(res =>{
      this.setState({ salesroomList: res })
    })
  }
    postDeviceList() {
        post({ url: API_device_findList }).then(res =>{
            this.setState({ deviceList: res })
        })
    }
  postHouseTypeSubmit(data) {
    const url =  API_CHECKLIST+ '?houseId=' + this.state.id
    this.setState({ submitLoading: true })

    return post({ url, data }).then(res => {
       // this.setState({ submitLoading: false })
    }).finally(err => {
      this.setState({ submitLoading: false })
    })
  }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {

                this.setState({submitLoading: true});
                values.transferDate = values.transferDate.format('YYYY-MM-DD');
                if(this.state.cycleDate){
                    values.cycleDate = this.state.cycleDate.format('YYYY-MM')
                }else{
                    message.error('登记失败, 请选择账单周期');
                    this.setState({submitLoading: false});
                    return;
                }

                if(this.state.registrationDate){
                    values.registrationDate = this.state.registrationDate.format('YYYY-MM-DD')
                }else{
                    message.error('登记失败, 请选择验收日期');
                    this.setState({submitLoading: false});
                    return;
                }

                values.transferMoney = values.transferMoney;
                values.attachIds = this.fileUploadRef.parseAttachToIds()
                post({url: config.API_device_writeOffAdd, data: values}).then(res => {
                    message.success('登记成功');
                    this.monitor.resolve()
                    this.handleCancel();
                }).catch(err => {
                    message.error(err.message || '登记失败');
                    this.setState({submitLoading: false});
                });
            }
        })
    }

    postNewTransferMoneyGet(cycleDate,registrationDate,projectId) {
        this.setState({ dataLoading: true })
        post({ url: API_GETROOMDEVICEBILLBYPROJECTIDANDCYCLEDATE,data:{"cycleDate" : cycleDate,"registrationDate":registrationDate,"projectId": projectId }  }).then(res => {
            this.props.form.setFieldsValue({"newTransferMoney":res})
            this.setState({ data: res,dataLoading: false })
        }).catch(err => {
            this.setState({ dataLoading: false });
        })
    }


  postHouseTypeGet(id) {
    this.setState({ dataLoading: true,repairReportId: id });
    this.setState({ dataLoading: false });
  }
  handleSubmit() {
    this.props.form.validateFields((err, values) => {
      if (err) return
      values.id = this.state.id || undefined

      //根据房源Id提交核对清单

      this.postHouseTypeSubmit(values).then(() => {
        this.close()
        this.monitor.resolve()
        message.success('保存成功')
      }).catch((e) => {
        message.error(e.message)
      })
    })
  }
  render(){
    const modalConfig = {
      title: '核销登记',
      visible: this.state.visible,
      footer: this.renderFooter(),
      width: 500,
      onCancel: () => this.close()
    }
  let {
      data,
      projectData,
  } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form
      const {datePickerOpen,datePickerOpen1,cycleDate,registrationDate,newTransferMoney} = this.state
    return (
      <Modal {...modalConfig}>
        <Spin spinning={this.state.dataLoading}>
          <div className="custom" style={{padding: 20}}>
            <Form  labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
              <Row>
                <Col span={24}>

                  <CustomRow >
                    <CustomCol  label="核销项目">
                        {getFieldDecorator('projectId', {
                            rules: [{
                                required: true, message: '请选择项目',
                            }],
                        })(
                            <Select
                                showSearch
                                // style={{ width: 275 }}
                                placeholder="请选择"
                                optionFilterProp={'children'}
                                onChange={(value) => {
                                    console.log('核销项目-----1');
                                    console.log('核销项目---'+value);
                                   this.setState({ "projectId": value });
                                   var newCycleDate = this.state.cycleDate;
                                   var newRegistrationDate = this.state.registrationDate;
                                   if(value!=null && newCycleDate!=null && newCycleDate!='' && newRegistrationDate!=null && newRegistrationDate!=''){
                                       this.postNewTransferMoneyGet(newCycleDate.format('YYYY-MM'),newRegistrationDate.format('YYYY-MM-DD'),value)
                                   }
                                }}
                            >
                                {projectData.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                            </Select>
                        )}
                    </CustomCol>
                  </CustomRow>
                    <CustomRow divider>
                        <CustomCol  label="账单周期">
                                <DatePicker
                                     value={cycleDate}
                                    open={datePickerOpen}
                                    mode="month"
                                    placeholder="请选择年份"
                                    format="YYYY-MM"
                                    onOpenChange={(status) => {
                                        if (status) {
                                            this.setState({datePickerOpen: true})
                                        } else {
                                            this.setState({datePickerOpen: false})
                                        }
                                    }}
                                    onPanelChange={(v) => {
                                        this.setState({
                                            cycleDate: v,
                                            datePickerOpen: false
                                        })
                                        console.log('核销账单周期-----1');
                                        console.log(v.format('YYYY-MM'));
                                        var projectId = this.state.projectId;
                                        var newRegistrationDate = this.state.registrationDate;
                                        if(v!=null && projectId!=null && projectId>0 && newRegistrationDate!=null && newRegistrationDate!=''){
                                            this.postNewTransferMoneyGet(v.format('YYYY-MM'),newRegistrationDate.format('YYYY-MM-DD'),projectId)
                                        }
                                    }}
                                    onChange={() => {
                                        console.log('核销账单周期-----2');
                                        this.setState({cycleDate: null})
                                        this.props.form.setFieldsValue({"newTransferMoney":""})
                                    }}
                                />
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol  label="验收日期">
                            <DatePicker
                                placeholder="请选择日期"
                                mode="date"
                                onChange={(value) => {
                                    console.log('核销账单周期-----2');
                                    this.setState({registrationDate:value})
                                    var projectId = this.state.projectId;
                                    var cycleDate = this.state.cycleDate;
                                    this.props.form.setFieldsValue({"newTransferMoney":""})
                                    if(value!=null && projectId!=null && projectId>0 && cycleDate!=null && cycleDate!=''){
                                        this.postNewTransferMoneyGet(cycleDate.format('YYYY-MM'),value.format('YYYY-MM-DD'),projectId)
                                    }

                                }}
                            />
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="实收金额(元)">
                            {getFieldDecorator('newTransferMoney', {
                                initialValue: 0,
                                rules: [{
                                    required: true, message: '请输入',
                                }]
                            })(
                                <InputNumber
                                    placeholder={'请输入'} disabled={true}
                                    min={0}
                                    formatter={value => value !== '' ? value : 0}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="转账日期">
                            {getFieldDecorator('transferDate', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: moment()
                            })(
                                <DatePicker />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="转账金额" subfix={<div>元</div>} subfixRight={30}>
                            {getFieldDecorator('transferMoney', {
                                initialValue: 0,
                                rules: [{
                                    required: true, message: '请输入',
                                }]
                            })(
                                <InputNumber
                                    placeholder={'请输入'}
                                    min={0}
                                    formatter={value => value !== '' ? value : 0}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="备注信息" colStyle={{ width: '350px', height: '100px' }}>
                            {getFieldDecorator('approvalRemark', {
                                initialValue: 0,
                                rules: [{
                                    required: true, message: '请输入',
                                }]
                            })(
                                <TextArea
                                    rows={3}
                                    cols={10}
                                    placeholder={'请输入'}
                                    style={{ height: '100px' }}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <DetailTitle title="转账回执" />
                    <FileUpload hideLabel ref={(ref) => this.fileUploadRef = ref} tableName="deviceBillWriteOff"  fileTypeList={[17]} isValueStyle={true}/>
                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
      </Modal>
    )

  }

    handleInfo=()=>{
        var leaseTermTime =  this.state.params.leaseTermTime;
        if(leaseTermTime==null){
            alert('请选择月份')
            return false;
        }else{
            const oa = document.createElement('a');
            oa.href = `${config.API_report_deviceRepairReportExprotDateExcel}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, null))}`;
            oa.setAttribute('target', '_blank');
            document.body.appendChild(oa);
            oa.click()
            return false;
        }

    }

    handleChoose = () => {
        if (this.chooseRef) {
            this.chooseRef.onShow(this.state.repairReportId).then(res => {
                this.postHouseTypeGet(this.state.id);
            }).catch(() => {})
        }
    }

    handleCancel = () => { //关闭页面
      //  this.props.handleCancel();
        this.close()
        this.setState({ data: {}, loading: false,submitLoading:false, title: "新增小区/楼栋",leaseTermTime:null });
    }
}



export default Form.create({ wrappedComponentRef: true })(DeviceDetail)


// WEBPACK FOOTER //
// ./src/page/DeviceBillWriteOff/deviceNewDetail.jsx